<section>
    <app-banner />
</section>
<section>
    <app-configurator />
</section>
<section class="bg-gray-150 py-13 py-md-14 mb-13 mb-md-14">
    <app-new-arrivals />
</section>
<section class="mb-13 mb-md-14">
    <app-banner-cta />
</section>
<section class="mb-13 mb-md-14">
    <app-our-products />
</section>
<section class="mb-13 mb-md-14">
    <app-video
        [title]="'HERO_VIDEO.title'"
        [backgroundImage]="'/assets/images/movie_main-bcg.png'"
        [videos]="['/assets/videos/main-video.av1.mp4', '/assets/videos/main-video.h264.mp4', '/assets/videos/main-video.hevc.mp4']"
        [btnText]="'HERO_VIDEO.btn'"
    />
</section>
<section class="mb-13 mb-md-14">
    <app-our-showroom titleStyle="secondary" />
</section>
<section>
    <div class="container-xxl">
        <h3 class="fs-29 lh-48 text-primary fw-700 mb-9 text-left">{{ 'PARTNERS.our_partners_title' | translate }}</h3>
    </div>
    <app-our-partners-logos />
</section>
